"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleLoader = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var web3_1 = __importDefault(require("web3"));
var _abi_1 = require("../../../../abi");
var LaunchpadIDO_json_1 = __importDefault(require("../../../../abi/LaunchpadIDO.json"));
var useSaleContract_1 = require("../../../../contracts/useSaleContract");
var _launchpadConstants_1 = require("../../../../launchpadConstants");
var _pool_1 = require("../../../../pool");
var utils_1 = require("../../../../shared/utils");
var multicall_1 = require("../../../../shared/utils/multicall");
var useLevelManager_1 = require("../../../../tiers/hooks/useLevelManager");
var utils_2 = require("./utils");
// To support 6 decimals
var SALE_RATE_DIVIDER = 1e6;
var SaleLoader = /** @class */ (function () {
    function SaleLoader(web3, config, instance) {
        this.web3 = web3;
        this.config = config;
        this.instance = instance;
    }
    SaleLoader.prototype.fetchInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getNonZero, methods, _a, rate, startDate, durationHours, tokensForSale, limits, baseAllocation, registerDate, registerDuration, fcfsDuration, totalWeights, minAllowedLevelMultiplier;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        getNonZero = function (value) { return web3_1.default.utils.toBN(value); };
                        methods = {
                            rate: function (v) { return (0, utils_2.toNumber)(v) / SALE_RATE_DIVIDER; },
                            startTime: function (v) { return dayjs_1.default.unix((0, utils_2.toNumber)(v)).toISOString(); },
                            duration: function (v) { return (0, utils_2.toNumber)(v) / 60 / 60; },
                            tokensForSale: function (v) {
                                return v ? web3_1.default.utils.toBN(v) : _this.config.tokensForSale;
                            },
                            getMinMaxLimits: function (_a) {
                                var min = _a[0], max = _a[1];
                                return ({
                                    min: getNonZero(min),
                                    max: getNonZero(max),
                                });
                            },
                            baseAllocation: function (v) {
                                return v ? web3_1.default.utils.toBN(v) : _this.config.baseAllocation;
                            },
                            registerTime: function (v) {
                                return (0, utils_2.toNumber)(v) ? dayjs_1.default.unix((0, utils_2.toNumber)(v)).toISOString() : '';
                            },
                            registerDuration: function (v) { return (v ? (0, utils_2.toNumber)(v) / 60 / 60 : 0); },
                            fcfsDuration: function (v) { return (v ? (0, utils_2.toNumber)(v) / 60 / 60 : 0); },
                            totalWeights: utils_2.toNumber,
                            minAllowedLevelMultiplier: utils_2.toNumber,
                        };
                        return [4 /*yield*/, (0, multicall_1.multicallTransformed)({
                                web3: this.web3,
                                abi: LaunchpadIDO_json_1.default,
                                address: this.config.address,
                                methods: methods,
                                returnCachedOnError: true,
                            })];
                    case 1:
                        _a = _b.sent(), rate = _a[0], startDate = _a[1], durationHours = _a[2], tokensForSale = _a[3], limits = _a[4], baseAllocation = _a[5], registerDate = _a[6], registerDuration = _a[7], fcfsDuration = _a[8], totalWeights = _a[9], minAllowedLevelMultiplier = _a[10];
                        this.config = __assign(__assign({}, this.config), { rate: rate, initRate: rate, startDate: startDate, durationHours: durationHours, tokensForSale: tokensForSale, limits: limits, baseAllocation: baseAllocation, registerDate: registerDate, registerDuration: registerDuration, fcfsDuration: fcfsDuration, totalWeights: totalWeights, minAllowedLevelMultiplier: minAllowedLevelMultiplier });
                        this.config.status = (0, _pool_1.getSaleStatus)(this.config);
                        return [2 /*return*/, this.config];
                }
            });
        });
    };
    SaleLoader.prototype.fetchRegular = function () {
        return __awaiter(this, void 0, void 0, function () {
            var methods, _a, tokensSold, raised, hasWhitelist, isTiered, levelsOpenAll, fcfsMultiplier, minBaseAllocation, reachedMinBaseAllocation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        methods = {
                            tokensSold: function (v) { return web3_1.default.utils.toBN(v); },
                            raised: function (v) { return web3_1.default.utils.toBN(v); },
                            whitelistEnabled: function (v) { return (v === null ? true : v); },
                            levelsEnabled: function (v) { return (v === null ? false : v); },
                            levelsOpenAll: function (v) { return (v === null ? false : v); },
                            getFcfsAllocationMultiplier: utils_2.toNumber,
                            minBaseAllocation: function (v) { return (v ? web3_1.default.utils.toBN(v) : _launchpadConstants_1.ZERO_BN); },
                            reachedMinBaseAllocation: function (v) { return v; },
                        };
                        return [4 /*yield*/, (0, multicall_1.multicallTransformed)({
                                web3: this.web3,
                                abi: LaunchpadIDO_json_1.default,
                                address: this.config.address,
                                methods: methods,
                                returnCachedOnError: true,
                            })];
                    case 1:
                        _a = _b.sent(), tokensSold = _a[0], raised = _a[1], hasWhitelist = _a[2], isTiered = _a[3], levelsOpenAll = _a[4], fcfsMultiplier = _a[5], minBaseAllocation = _a[6], reachedMinBaseAllocation = _a[7];
                        this.config = __assign(__assign({}, this.config), { tokensSold: tokensSold, raised: raised, hasWhitelist: hasWhitelist, isTiered: isTiered, levelsOpenAll: levelsOpenAll, isPublic: !hasWhitelist && !isTiered, fcfsMultiplier: fcfsMultiplier, minBaseAllocation: minBaseAllocation, reachedMinBaseAllocation: reachedMinBaseAllocation });
                        this.config.status = (0, _pool_1.getSaleStatus)(this.config);
                        return [2 /*return*/, this.config];
                }
            });
        });
    };
    SaleLoader.prototype.fetchUser = function (account) {
        var _this = this;
        var proxy = (0, useSaleContract_1.getSaleProxyContract)(this.web3);
        var useProxy = this.config.startDate &&
            Date.parse(this.config.startDate) / 1000 <
                _abi_1.CONTRACTS.saleProxy.v1.useForSalesBefore;
        return (this.config.startDate && useProxy
            ? (0, utils_1.call)(proxy, 'getUserState', [this.config.address, account])
            : (0, utils_1.call)(this.instance, 'getUserState', [account]))
            .then(function (data) {
            return __assign(__assign({}, (0, utils_2.cleanObjKeys)(data)), { weight: (0, utils_2.toNumber)(data.weight) / useLevelManager_1.MULTIPLIER_DECIMALS, contributed: (0, utils_2.toBN)(data.contributed), balance: (0, utils_2.toBN)(data.balance), totalAlloc: (0, utils_2.toBN)(data.totalAlloc), wlAlloc: (0, utils_2.toBN)(data.wlAlloc), fcfsAlloc: (0, utils_2.toBN)(data.fcfsAlloc), levelAlloc: (0, utils_2.toBN)(data.levelAlloc) });
        })
            .catch(function (e) {
            console.error('Failed to fetch user level state', _this.config.address, e);
        });
    };
    return SaleLoader;
}());
exports.SaleLoader = SaleLoader;
